import * as HydraNavState from '@customerio/hydra-nav-state';
import * as HydraPlumaState from '@customerio/hydra-pluma-state';

export default function injectGlobals() {
  Object.assign(window, {
    HydraNavState,
    HydraPlumaState,
  });
}
